<script setup>
// BonBoZ: ô chọn chủ đề màu khung, đặt trong Cài đặt cá nhân — đúng chỗ Pancake
// đặt nó. Bảng màu và cách áp dụng nằm ở `helper/chuDe.js`.
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { CAC_CHU_DE, chonChuDe, chuDeHienTai } from 'dashboard/helper/chuDe';

const { t } = useI18n();
const { updateUISettings } = useUISettings();

// Đọc chủ đề ĐANG HIỆN chứ không đọc uiSettings: uiSettings chỉ đổi sau khi
// lưu xong (0,4 s + một vòng mạng), dấu tích mà đi theo nó thì nền đã đổi rồi
// mà dấu tích còn nằm ở ô cũ — nhìn như bấm không ăn.
const dangChon = computed(() => chuDeHienTai.value);

// Tải sẵn các bản logo để lần đầu đổi sang nền sáng / xanh lá không có một
// nhịp logo biến mất chờ tải file mới.
onMounted(() => {
  new Set(CAC_CHU_DE.map(c => c.logo)).forEach(src => {
    const anh = new Image();
    anh.src = src;
  });
});

// Khoá tĩnh để linter bắt được bản dịch thiếu.
const tenChuDe = computed(() => ({
  sang: t('BONBOZ.CHU_DE_KHUNG.SANG'),
  xanh: t('BONBOZ.CHU_DE_KHUNG.XANH'),
  'hoang-hon': t('BONBOZ.CHU_DE_KHUNG.HOANG_HON'),
  dem: t('BONBOZ.CHU_DE_KHUNG.DEM'),
  'ky-lan': t('BONBOZ.CHU_DE_KHUNG.KY_LAN'),
  song: t('BONBOZ.CHU_DE_KHUNG.SONG'),
  'trai-dat': t('BONBOZ.CHU_DE_KHUNG.TRAI_DAT'),
  'co-bon-la': t('BONBOZ.CHU_DE_KHUNG.CO_BON_LA'),
}));

let henLuu = null;
const chon = ten => {
  // Áp ngay cho mắt thấy, rồi mới lưu — chờ API xong mới đổi màu thì bấm xong
  // có một nhịp "không thấy gì" và người ta bấm lại.
  chonChuDe(ten);
  // Lưu sau một nhịp và chỉ lưu cú bấm cuối. Mỗi lần lưu, server trả cả hồ sơ
  // người dùng về và store ghi đè — bấm nhanh qua lại thì các phản hồi về không
  // theo thứ tự, màu nhảy ngược về ô đã bỏ, và mỗi phản hồi lại kéo cả app vẽ
  // lại một lượt nên giật.
  clearTimeout(henLuu);
  henLuu = setTimeout(() => updateUISettings({ bonboz_chu_de: ten }), 400);
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <div
      class="grid grid-cols-2 gap-3 sm:grid-cols-4"
      role="radiogroup"
      :aria-label="$t('BONBOZ.CHU_DE_KHUNG.TIEU_DE')"
    >
      <button
        v-for="chuDe in CAC_CHU_DE"
        :key="chuDe.ten"
        type="button"
        role="radio"
        :aria-checked="dangChon === chuDe.ten"
        :aria-label="tenChuDe[chuDe.ten]"
        :title="tenChuDe[chuDe.ten]"
        class="relative h-24 rounded-xl outline outline-1 transition-shadow outline-n-weak focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-n-brand"
        :class="
          dangChon === chuDe.ten
            ? 'ring-2 ring-offset-2 ring-n-brand ring-offset-n-solid-1'
            : 'hover:shadow-md'
        "
        :style="{ background: chuDe.nen }"
        @click="chon(chuDe.ten)"
      >
        <!-- Emoji là dấu nhận diện của Pancake cho từng chủ đề, chỉ để trang
             trí — tên thật nằm ở aria-label/title. -->
        <span
          class="absolute bottom-2.5 text-lg leading-none ltr:left-3 rtl:right-3"
          aria-hidden="true"
        >
          {{ chuDe.emoji }}
        </span>
        <span
          v-if="dangChon === chuDe.ten"
          class="grid absolute bottom-2 place-items-center rounded-full size-5 ltr:right-2 rtl:left-2"
          :style="{
            background: `rgb(${chuDe.chu})`,
            color: chuDe.nen.startsWith('rgb')
              ? chuDe.nen
              : `rgb(${chuDe.daiDien})`,
          }"
          aria-hidden="true"
        >
          <span class="i-lucide-check size-3.5" />
        </span>
      </button>
    </div>
  </div>
</template>
